import { postRedeemCoupon } from './postRedeemCoupon';
import { postBatchRedeemCoupons } from './postBatchRedeemCoupons';

export const couponService = {
  postRedeemCoupon: postRedeemCoupon,
  postBatchRedeemCoupons,
};
